import { GraphObject, Margin, Panel, Placeholder, Spot } from 'gojs';
import { LINEAGE_PARTS } from '../../../../../../state/data-lineage-diagram';
import { groupHeader } from './group-header';

const $ = GraphObject.make;

export const contentPanel = () =>
  $(
    Panel,
    Panel.Vertical,
    {
      name: LINEAGE_PARTS.GROUP_PANEL,
      defaultAlignment: Spot.Left,
      padding: new Margin(0, 5),
    },
    groupHeader(),
    groupPlaceholder(),
  );

const groupPlaceholder = () =>
  $(Placeholder, {
    padding: new Margin(5, 5, 10, 5),
  });
